import axios from "axios";

import { config } from "../config/config";

const packageJson = require("../../package.json");

export const invokeApi = async (url, params, cookies) => {
  try {
    let headers = {
      "Content-Type": "application/json",

      appversion: packageJson.version,

      platform: "web",
    };

    if (
      cookies &&
      cookies[config.cookieName] &&
      cookies[config.cookieName].token &&
      cookies[config.cookieName].loginUserId
    ) {
      headers.Authorization = "Bearer " + cookies[config.cookieName].token;

      headers.loginUserId = cookies[config.cookieName].loginUserId;
    }

    if (
      cookies &&
      cookies[config.sessionCookie] &&
      cookies[config.sessionCookie].sessionId
    ) {
      headers.sessionId = cookies[config.sessionCookie].sessionId;
    }

    // return await axios.post(url, params);
    return await axios.post(url, params,);
  } catch ({ response }) {
    return response;
  }
};

export const invokeFormDataApi = async (url, formData, cookies) => {
  try {
    let headers = {
      "Content-Type": "multipart/form-data",
      appversion: packageJson.version,
      platform: "web",
    };
    if (
      cookies &&
      cookies[config.cookieName] &&
      cookies[config.cookieName].token &&
      cookies[config.cookieName].loginUserId
    ) {
      headers.Authorization = "Bearer " + cookies[config.cookieName].token;
      headers.loginUserId = cookies[config.cookieName].loginUserId;
    }
    if (
      cookies &&
      cookies[config.sessionCookie] &&
      cookies[config.sessionCookie].sessionId
    ) {
      headers.sessionId = cookies[config.sessionCookie].sessionId;
    }
    return await axios.post(url, formData, { headers: headers });
  } catch ({ response }) {
    return response;
  }
};

export const apiList = {
  // traffic tracking
  addWebTraffic: "/web/addWebTraffic",

  // user manager
  userLogin: "/login",
  userAdd: "/addUser",
  getUsers: "/getUsers",
  getUser: "/getUser",
  updateUser: "/updateUser",
  deleteUser: "/deleteUser",
  changePassword: "/changePassword",

  // leads manager
  getLeads: "/getLeads",
  updateLeadStatus: "/updateLead",
  addLead: "/addLead",

  // blog manager
  addBlog: "/addBlog",
  getBlogs: "/getBlogs",
  getBlog: "/getBlog",
  updateBlog: "/updateBlog",
  deleteBlog: "/deleteBlog",
  approveBlog: "/approveBlog",
  getArticles: "/getArticles",
  getArticleByOgUrl: "/getArticleByOgUrl",

  // seo manager
  addSite: "/addSite",
  getAllSites: "/getAllSites",
  getsite: "/getSite",
  updateSite: "/updateSite",
  addMetaData: "/addMetaData",
  getMetaDataBySite: "/getMetaDataBySite",
  updateMetaData: "/updateMetaData", 

  // web settings
  addLocation: "/addLocation",
  getLocations: "/getLocations",

  // add new page
  addNewPage: "/addNewPage",
  getPages: "/getPages",
  getPageByID: "/getPageByID",

  //get page details by ogUrl
  getPage: "/getPage",

  getLocationData: "/getLocationData",

  //update seo faqs
  updateSeoFaqs: "/updateSeoFaqs",

  getSeoFaqsBySiteId: "/getSeoFaqsBySiteId",

  //programme manager
  addProgramme: "/addProgramme",
  getProgrammes: "/getProgrammes",
  getProgramme: "/getProgramme",
  updateProgramme: "/updateProgramme",
  deleteProgramme: "/deleteProgramme",

  //publication manager
  addPublication: "/addPublication",
  getPublications: "/getPublications",
  getPublication: "/getPublication",
  updatePublication: "/updatePublication",
  deletePublication: "/deletePublication",
  
  //features
  addFeature: "/addFeature",
  getFeatures: "/getFeatures",
  getFeature: "/getFeature",
  updateFeature: "/updateFeature",
  deleteFeature: "/deleteFeature",

  //people

  addPerson: "/addPerson",
  getPeople: "/getPeople",
  getPerson: "/getPerson",
  updatePerson: "/updatePerson",
  deletePerson: "/deletePerson",
};
